<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import forminput from "@/router/views/FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrKontrolStandart from "@/models/StrKontrolStandart";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
export default {
  mixins: [Api, Sabit, StrKontrolStandart],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    formcombobox,
    forminput,
    formtextarea
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        if (!this.FormData.UstId || this.FormData.UstId == "0") {
          this.$delete(this.FormData, "UstId");
        }
        if (this.AddEdit == "Add") {
          this.Post("StrKontrolStandart", this.FormData);
          this.$bvModal.hide("StrKontrolStandart");
        } else {
          this.Update("StrKontrolStandart", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("StrKontrolStandart");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrKontrolStandart"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrKontrolStandart.AddEdit.FormTitleEdit')
          : $t('StrKontrolStandart.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <forminput
          :FormDataType="FormDataType.SiraNo"
          :Value="FormData.SiraNo"
          :v="$v.FormData.SiraNo"
          @input="FormData.SiraNo = $event"
        />

        <formcombobox
          :FormDataType="FormDataType.AnaGrupId"
          :Value="FormData.AnaGrupId"
          :v="$v.FormData.AnaGrupId"
          @input="FormData.AnaGrupId = $event"
        />

        <forminput
          :FormDataType="FormDataType.StandartKodNo"
          :Value="FormData.StandartKodNo"
          :v="$v.FormData.StandartKodNo"
          @input="FormData.StandartKodNo = $event"
        />
        <forminput
          :FormDataType="FormDataType.StandartGenelSarti"
          :Value="FormData.StandartGenelSarti"
          :v="$v.FormData.StandartGenelSarti"
          @input="FormData.StandartGenelSarti = $event"
        /> 

                <formtextarea
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        /> 
        <button class="btn btn-primary" type="submit">
          {{ $t("StrKontrolStandart.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
